export default __webpack_public_path__ + "static/media/icn-phone.2a9982a9.svg";